import {Box, styled} from '@mui/material';

export const StyledMainContainer = styled(Box)(({theme}) => ({
	width: '100%',
	paddingBottom: 72,
	[theme.breakpoints.up('sm')]: {
		paddingBottom: 0,
	},
}));

export const StyledFooterContainer = styled(Box)(({theme}) => ({
	margin: 'auto 0 72px',
	paddingTop: 40,
	[theme.breakpoints.up('sm')]: {
		margin: 'auto 0 0',
		'& footer': {
			marginInline: 24,
		},
	},
	[theme.breakpoints.up('md')]: {
		margin: 'auto 24px 0',
		'& footer': {
			marginInline: 0,
		},
	},
}));

export const ProceduresContainer = styled('div')(({theme}) => ({
	width: '100%',
	margin: '0 auto',
	marginTop: '32px',
	padding: '16px',
	borderRadius: '8px',
	backgroundColor: theme.palette.background.paper,
	display: 'flex',
	flexDirection: 'column',
	gap: '28px',
}));

export const SearchResultContainer = styled('div')(() => ({
	width: '100%',
	padding: '12px 0',
}));

export const ProcedureListScrollArea = styled(Box)(() => ({
	maxHeight: 'min(300px, 50vh)',
	overflowY: 'auto',
	minHeight: 0,
	width: '100%',
	padding: '0 12px',
}));
